<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" v-decorator="['companyCode', validatorRules.companyCode]"
                                   :trigger-change="true" dict="biz_insurance_company,name,code" placeholder="请输入保险公司">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发票类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['invoiceType']" :trigger-change="true" dictCode="bms_invoice_type" placeholder="请选择发票类型"/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="发票开具内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-select v-decorator="['invoiceContent']" placeholder="请选择发票开具内容">
                <a-select-option value="佣金">佣金</a-select-option>
                <a-select-option value="手续费">手续费</a-select-option>
                <a-select-option value="咨询费">咨询费</a-select-option>
              </a-select> -->
              <j-dict-select-tag type="list" v-decorator="['invoiceContent']" :trigger-change="true" dictCode="bms_invoice_content" placeholder="请选择发票开具内容"/>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerName']" placeholder="请输入名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="纳税人识别号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerIdentification']" placeholder="请输入纳税人识别号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerAddress']" placeholder="请输入地址"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerPhone']" placeholder="请输入电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerBankName']" placeholder="请输入开户行"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="开户行账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['consumerBankNumber']" placeholder="请输入开户行账号"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"

  export default {
    name: 'BizInsuranceInvoiceConfigForm', // 保险人发票信息配置
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          companyCode: {
            rules: [
              { required: true, message: '请选择公司' },
            ]
          }
        },
        url: {
          add: "/bms/insuranceCompanyInvoice/add",
          edit: "/bms/insuranceCompanyInvoice/edit",
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'companyCode','invoiceType','invoiceContent','consumerName',
            'consumerIdentification','consumerAddress','consumerPhone','consumerBankName','consumerBankNumber'))
        })
      },

      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'companyCode','invoiceType','invoiceContent','consumerName',
          'consumerIdentification','consumerAddress','consumerPhone','consumerBankName','consumerBankNumber'))
      },
    }
  }
</script>